import { DependencyList, useCallback } from 'react'
import {
	sisetuCommentApi,
	sisetuCommentApiBy
} from 'interface/endpoints'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'

import {
	SisetuCommentFormData,
	SisetuCommentResult,
	SisetuCommentResultList
} from './types'

export * from './types'

export const useListSisetuComment = (
	sisetuCode: string | null | undefined,
	deps?: DependencyList
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!sisetuCode) return null
      return ApiGetWithToken<SisetuCommentResultList>(
        apiAccess,
				sisetuCommentApi(sisetuCode, '/list'),
        cancelToken
      )
    },
		[sisetuCode]
	),
	deps
)

export const usePostSisetuComment = (
  sisetuCode: string,
	callback?: {
    onPosted?: (result: SisetuCommentResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SisetuCommentFormData, SisetuCommentResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        sisetuCommentApi(sisetuCode),
				form,
				cancelToken,
				webSocketId
			)
		},
		[sisetuCode]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSisetuComment = (
  sisetuCode: string,
	callback?: {
    onEditted?: (result: SisetuCommentResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<{ commentId: number, form: SisetuCommentFormData }, SisetuCommentResult>(
	useCallback(
		(apiAccess, cancelToken, { commentId, form }, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        sisetuCommentApiBy(sisetuCode, commentId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[sisetuCode]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteSisetuComment = (
  sisetuCode: string | undefined | null, 
	callback?: {
    onDeleted?: (targetListId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, commentId, webSocketId) => {
			if (!sisetuCode) return null
			return ApiDeleteWithToken(
				apiAccess,
        sisetuCommentApiBy(sisetuCode, commentId),
				cancelToken,
				webSocketId
			)
		},
		[sisetuCode]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
